import React from 'react';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import Callout from '@grnhse/seedling/lib/azalea/components/callout';
import Dismissable from '@grnhse/seedling/lib/azalea/components/dismissable';
import { ErrorIcon } from '@grnhse/seedling/lib/azalea/icons';
import { withLocalePrefix } from 'shared/utils/translation';
import $ from 'legacy/jquery';

const t = withLocalePrefix('gdpr.consent_extension_email.nudge');

const ConsentExtensionEmailNudge = () => {
  return (
    <Dismissable
      storageKeyPrefix="consent_extension_email_nudge"
      render={NudgeContent}
    />
  );
};

// @ts-expect-error - TS7031 - Binding element 'dismissAndHide' implicitly has an 'any' type.
const NudgeContent = ({ dismissAndHide }) => {
  const openConsentExtensionEmail = () => {
    $(window.document).trigger('gdpr.openConsentExtensionEmail');
  };

  return (
    <Callout
      flavor="warning"
      title={t('title')}
      // @ts-expect-error Callout needs to be configured to take arbitrary icons
      icon={ErrorIcon}
      rightComponent={
        <Button onClick={openConsentExtensionEmail}>{t('configure')}</Button>
      }
      onDismiss={dismissAndHide}
    >
      {t('message')}
    </Callout>
  );
};

export default ConsentExtensionEmailNudge;
